'use client'

import React, { useEffect, useRef, useState } from 'react'
import { RichText } from '../RichText'

interface PartnerIntroProps {
  data: Parameters<typeof RichText>[0]['data']
  className?: string
}

export function PartnerIntro({ data, className }: PartnerIntroProps) {
  const [expanded, setExpanded] = useState(false)
  const [needsExpand, setNeedsExpand] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = contentRef.current
    if (!el || expanded) return

    const checkOverflow = () => {
      setNeedsExpand(el.scrollHeight > el.clientHeight + 1)
    }

    checkOverflow()

    const observer = new ResizeObserver(checkOverflow)
    observer.observe(el)
    return () => observer.disconnect()
  }, [expanded, data])

  return (
    <div>
      <div
        ref={contentRef}
        className={
          expanded
            ? undefined
            : 'sm:max-h-[5.5rem] md:max-h-[11rem] sm:overflow-hidden relative'
        }
      >
        <RichText data={data} className={className} />
        {!expanded && needsExpand && (
          <div
            className="hidden sm:block absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-stone to-transparent pointer-events-none"
            aria-hidden
          />
        )}
      </div>
      {needsExpand && (
        <button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          aria-expanded={expanded}
          className="mt-2 text-sm font-medium text-brand-blue hover:text-brand-blue/80 transition-colors"
        >
          {expanded ? 'Show less' : 'Read more'}
        </button>
      )}
    </div>
  )
}
